<template>
  <el-tooltip class="item" effect="dark" :content="`${listObj[value]} （${value}）`" placement="top" :disabled="!value">
    <div class="search-select">
      <el-select v-bind="$attrs" clearable v-model="id" remote filterable :placeholder="placeholder" @change="change" :remote-method="remoteMethod" :loading="loading" @clear="clear" style="width:100%">
        <el-option v-for="item in originList" :key="item.value" :label="item.label" :value="item.value">
          <span class="code-search-label" :title="item.label">{{ item.label }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
        </el-option>
      </el-select>

    </div>
  </el-tooltip>
</template>
<script>
export default {
  props: {
    value: [String, Number],
    placeholder: String,
    option: Object,
    type: {
      type: String,
      default: "project"
    }
  },
  data() {
    return {
      id: "",
      list: [],
      listObj: {},
      loading: false,
      showAddModal: false,
      getListStatus: false
    }
  },
  watch: {
    value(val) {
      this.id = val
      if (val && !this.getListStatus) {
        this.setCode(val)
      }
    }
  },
  computed: {
    originList() {
      return this.list || this.list
    }
  },
  methods: {
    remoteMethod(query) {
      this.getList(query)
    },
    async getList(query) {
      try {
        this.list = await this.$Api.post("dropdown_search", {module: this.type, search_content: query})
        let obj = {}
        for (let item of this.list) {
          obj[item.value] = item.label
        }
        this.listObj = obj
        this.getListStatus = true
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    change(id) {
      this.$emit("input", id)
      let code = `${this.type}_code`
      let name = `${this.type}_name`
      let params = {}
      params[code] = id
      params[name] = this.listObj[id]
      this.$emit("change", params)
    },
    getLabelByCode(code) {
      return new Promise(async (resolve, reject) => {
        try {
          let data = await this.$Api.post("dropdown_label", {module: this.type, value: code})
          this.list = [{label: data, value: code}]
          let obj = {}
          for (let item of this.list) {
            obj[item.value] = item.label
          }
          this.listObj = obj
          resolve(true)
        } catch (e) {
          this.$message.error(e.errormsg)
        }
      })
    },
    async setCode(value) {
      await this.getLabelByCode(value)
      this.id = value
      this.change(this.id)
    },
    clear() {
      this.getList("")
      this.change("")
    },
  },
  async mounted() {
    if (this.value) {
      await this.setCode(this.value)
    } else {
      this.clear()
    }
  }
}
</script>
<style lang="scss" scoped>
.code-search-label {
  width: 300px;
  text-overflow: ellipsis;
  float: left;
  overflow: hidden;
}

.search-select {
  display: flex;
  justify-content: space-between;
  width: 100%;

  .btn-add {
    margin-left: 10px;
  }
}
</style>
